module.exports = __webpack_public_path__ + "img/35.288871c2.jpg";